var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"icons8-twitter","d":"M33.887,5.248a12.717,12.717,0,0,1-3.953,1.13A7.517,7.517,0,0,0,33.04,2.565a12.818,12.818,0,0,1-4.377,1.694A7.389,7.389,0,0,0,23.439,2,6.93,6.93,0,0,0,16.52,8.919a5.294,5.294,0,0,0,.141,1.553A19.31,19.31,0,0,1,2.4,3.271,6.065,6.065,0,0,0,1.412,6.8,7.089,7.089,0,0,0,4.518,12.59a10.01,10.01,0,0,1-3.106-.847v.141a6.848,6.848,0,0,0,5.507,6.777,7.154,7.154,0,0,1-1.836.282A3.909,3.909,0,0,1,3.812,18.8a6.694,6.694,0,0,0,6.5,4.8,14.125,14.125,0,0,1-8.613,2.965A6.874,6.874,0,0,1,0,26.427a19.765,19.765,0,0,0,10.59,3.106c12.849,0,19.768-10.59,19.768-19.768V8.919a14.548,14.548,0,0,0,3.53-3.671","transform":"translate(0 -2)","fill":"#979797"}));
}

Twitter.defaultProps = {"width":"33.887","height":"27.533","viewBox":"0 0 33.887 27.533"};

module.exports = Twitter;

Twitter.default = Twitter;
